import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import {withNamespaces} from 'react-i18next';

let IconLock = require('../img/ic_lock.svg');
const Wrapper = styled.div`
  position: relative;
  text-align: center;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: -5px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  text-align: center;
  z-index: 1;
  background-color: white;
  padding-top: 11px;
`;

class LockToggle extends Component {
  state = {hovered: false};

  render() {
    const {
      props: {locked, toggleLock, t},
      state: {hovered},
    } = this;
    const buttonVisible = !locked || hovered;
    return (
      <Wrapper onMouseEnter={() => this.setState({hovered: true})} onMouseLeave={() => this.setState({hovered: false})}>
        <span style={{visibility: buttonVisible ? 'visible' : 'hidden'}}>
          <FlatButton
            onClick={() => toggleLock(!locked)}
            label={locked ? t('lockToggle.deviceUnlock') : t('lockToggle.deviceLock')}
          />
        </span>
        <IconWrapper style={{visibility: buttonVisible ? 'hidden' : 'visible'}}>
          <img
            src={IconLock}
            alt={`${t('lockToggle.device')} ${locked ? '' : t('lockToggle.not')} ${t('lockToggle.locked')}`}
            width={15}
          />
        </IconWrapper>
      </Wrapper>
    );
  }
}
export default withNamespaces()(LockToggle);



// WEBPACK FOOTER //
// ./src/components/LockToggle.js